
import { iconFactory } from '../../utils/iconFactory';

export const ArrowDownIcon = iconFactory({
  componentName: 'ArrowDownIcon',
  viewBox: '0 0 32 32',
  title: 'arrow-down',
  g: `<path d="M16 23.2l-12.8-12.167 2.349-2.233 10.451 9.935 10.452-9.935 2.348 2.233-12.8 12.167z"/>`,
  gThemed: {
    // No themed variants provided
  },
});

export default ArrowDownIcon;
